import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as StatisticsActions from './statistics.action';
import { Observable } from 'rxjs';
import * as Selectors from './statistics.selector';
import { StatsFilters } from '../../../models/statistics/statistics.model';

@Injectable()
export class StatisticsFacade {
  saleFullViewingLog$ = this.store.select(Selectors.selectSaleFullViewingLog);
  saleViewingSummary$ = this.store.select(Selectors.saleViewingSummary);
  saleFullViewingLogLoaded$ = this.store.select(Selectors.selectSaleFullViewingLogLoaded);
  saleViewingSummaryLoaded$ = this.store.select(Selectors.saleViewingSummaryLoaded);
  selectConsignorSaleLoaded$ = this.store.select(Selectors.selectConsignorSaleLoaded);
  selectConsignorSale$ = this.store.select(Selectors.selectConsignorSale);
  statError$: Observable<any> = this.store.select(Selectors.selectStatError);
  selectMarkAsArchived$: Observable<any> = this.store.select(Selectors.selectMarkAsArchived);
  constructor(private store: Store) {}

  loadFullViewingLog(saleUID: string, uid?: string, saleMemberId?: number, typo?: string, filter: StatsFilters = null): void {
    this.store.dispatch(StatisticsActions.GetSaleFullViewingLog({ saleUID, uid, saleMemberId, typo, filter }));
  }

  loadViewingSummary(saleUID: string, uid?: string, saleMemberId?: number, typo?: string, filter: StatsFilters = null): void {
    this.store.dispatch(StatisticsActions.GetSaleViewingSummary({ saleUID, uid, saleMemberId, typo, filter }));
  }

  loadConsignorSales(saleUID: string, consignorUID?: string): void {
    this.store.dispatch(StatisticsActions.getConsignorSales({ saleUID, consignorUID }));
  }

  markAsArchive(activityLogId: number,active:boolean) {
    this.store.dispatch(StatisticsActions.MarkAsArchive({ activityLogId, active }));
  }
}
